import { atom } from 'jotai';
import { getInitialState } from './constants';
import type { FeatureFlags } from './types';

export const featureFlagsAtom = atom<FeatureFlags>(getInitialState());
